/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../../components/AlertDialog";
import MaterialReactTableManageAdmins from "components/MaterialReactTableManageAdmins";
import { Box, Button } from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';

export default function ManageAdmins(props) {
  const { api } = useContext(FirebaseContext);
  const {
    updateProfile,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    adminEmailSignUp,
    clearLoginError,
    fetchUsers,
  } = api;

  const branchManagementReducer = useSelector((state) => state.branchData);
  const auth = useSelector((state) => state.auth);
  const usersdata = useSelector((state) => state.usersdata);
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const branchLookup = Array.isArray(branchManagementReducer.branches)
    ? branchManagementReducer.branches.reduce((lookup, branch) => {
        lookup[branch.branchId] = branch.BranchName;
        return lookup;
      }, {})
    : {};

  const refreshData = async () => {
    try {
      if (fetchUsers) {
        console.log(`Refreshing`)
        await dispatch(fetchUsers());
      }
      setRefreshTrigger(prev => prev + 1);
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
  };

  useEffect(() => {
    console.log("Users data updated:", usersdata.admins);
    if (usersdata.users) {
      const filteredAdmins = usersdata.admins.filter((user) => user.userType === "admin");
      console.log("Filtered admins:", filteredAdmins);
      setData(filteredAdmins);
    } else {
      setData(usersdata.admins);
    }
  }, [usersdata.users, usersdata.admins, refreshTrigger]);

  useEffect(() => {
    console.log("Redux usersdata changed:", usersdata);
  }, [usersdata]);

  useEffect(() => {
    console.log("Local data state changed:", data);
  }, [data]);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  const columns = [
    {
      id: "id",
      header: "Hidden id",
      columns: [
        {
          accessorKey: "id",
          header: "User id",
          enableEditing: false,
          Edit: () => null,
          enableHiding: true,
        },
      ],
    },
    {
      accessorKey: "firstName",
      header: language.first_name,
    },
    {
      accessorKey: "lastName",
      header: language.last_name,
    },
    {
      accessorKey: "identityNumber",
      header: "Identity Number",
    },
    {
      accessorKey: "email",
      header: language.email,
      Cell: ({ cell }) =>
        features.AllowCriticalEditsAdmin ? cell.getValue() : "Hidden for Demo",
    },
    {
      accessorKey: "password",
      header: "Password",
    },
    {
      accessorKey: "mobile",
      header: language.mobile,
      Cell: ({ cell }) =>
        features.AllowCriticalEditsAdmin ? cell.getValue() : "Hidden for Demo",
    },
    {
      accessorKey: "adminHomeOffice",
      header: "Office",
    },
    {
      accessorKey: "practiceAdminActiveStatus",
      header: language.account_approve,
      Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
    },
    {
      accessorKey: "isSuperAdmin",
      header: "Super Admin",
      type: "boolean",
      Cell: ({ cell }) => {
        const isSuperAdmin = Boolean(cell.getValue());
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              backgroundColor: isSuperAdmin ? 'success.light' : 'grey.300',
              color: isSuperAdmin ? 'success.dark' : 'grey.700',
              padding: '4px 8px',
              borderRadius: '6px',
              fontSize: '0.85rem',
              fontWeight: '600',
              textAlign: 'center',
            }}
          >
            {isSuperAdmin ? <DoneIcon fontSize="small" /> : <CloseIcon fontSize="small" />}
            {isSuperAdmin ? 'Yes' : 'No'}
          </Box>
        );
      },
    },
  ];

  const handleAddRow = async (newRow) => {
    const res = await checkUserExists(newRow);
    if (res.users && res.users.length > 0) {
      alert(language.user_exists);
    } else if (res.error) {
      alert(language.email_or_mobile_issue);
    } else {
      newRow["createdByAdmin"] = true;
      newRow["isSuperAdmin"] = newRow.isSuperAdmin || false;
      newRow["userType"] = "admin";
      newRow["adminHomeOffice"] = newRow.adminHomeOffice;
      newRow["createdAt"] = new Date().toISOString();
      newRow["referralId"] =
        newRow.firstName.toLowerCase() +
        Math.floor(1000 + Math.random() * 9000).toString();
      newRow["username"] =
        newRow.firstName.toLowerCase() +
        newRow.lastName.toLowerCase() +
        Math.floor(1000 + Math.random() * 9000).toString();

      const role = auth.info.profile.userType;
      if (role === "admin") {
        newRow["admin"] = auth.info.uid;
      }

      console.log(`newRow: ${JSON.stringify(newRow)}`);
      const result = await emailSignUp(newRow);
      console.log(`result: ${JSON.stringify(result)}`)
      if (result.uid) {
        setCommonAlert({
          open: true,
          msg: language.account_create_successfully,
        });
        // Refresh data after successful creation
        setTimeout(() => {
          refreshData();
        }, 500);
      } else {
        setCommonAlert({
          open: true,
          msg: language.reg_error,
        });
      }
    }
  };

  const handleUpdateRow = async (updatedRow) => {
    console.log("New Data in update admin method:", updatedRow);

    updatedRow["adminHomeOffice"] = updatedRow?.adminHomeOffice;
    updatedRow["isSuperAdmin"] = Boolean(updatedRow.isSuperAdmin);
    
    if (!updatedRow.adminHomeOffice) {
      console.log("Admin Home Office is undefined");
      return;
    }

    try {
      await dispatch(editUser(updatedRow.id, updatedRow));
      
      // Refresh data after successful update
      setTimeout(() => {
        refreshData();
      }, 500);
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  const handleDeleteRow = async (rowToDelete) => {
    if (features.AllowCriticalEditsAdmin) {
      try {
        await dispatch(deleteUser(rowToDelete.id));
        // Refresh data after successful deletion
        setTimeout(() => {
          refreshData();
        }, 500);
      } catch (error) {
        console.error("Error deleting user:", error);
      }
    } else {
      alert(language.demo_mode);
    }
  };

  return usersdata.loading || auth.loading ? (
    <CircularLoading />
  ) : (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button 
          variant="contained" 
          onClick={refreshData}
          startIcon={<RefreshIcon />}
          disabled={usersdata.loading || auth.loading}
          sx={{
            backgroundColor: '#009ad8',
            '&:hover': {
              backgroundColor: '#007bb5',
            },
          }}
        >
          Refresh
        </Button>
      </Box>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <MaterialReactTableManageAdmins
        data={data}
        columns={columns}
        userInitialState={{
          columnVisibility: { id: false },
        }}
        onRowAdd={handleAddRow}
        onRowUpdate={handleUpdateRow}
        onRowDelete={handleDeleteRow}
      />
    </Box>
  );
}